// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-scroll-container{
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
}
.user-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  max-width: 900px;
  justify-content: center;
  align-items: flex-end;
  margin: 0 auto;
}

.user-scroll-container2{
  overflow-x: auto;
  white-space: nowrap;
  width: 114%;
}

.user-header {
  height: 150px;
  width: 100%;
  display: flex;
  align-items: center;
  background: #a03d4d;
  color: white;
  padding: 15px;
  border-radius: 5px 5px 0 0;
}
.resume24 {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  /* border: 1px solid #ddd;
  border-radius: 8px; */
  overflow: hidden;
  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);
} 
.back-button24{
  position: relative;
    background-color: #474559 !important;
    color: #fff !important;
    border: 2px solid white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: large;
    margin-top: 8px;
    left: 5px;
    display: block;
  }
  .db24 {
    justify-self: end;
  }
  .db24{
  
    background-color:#474559 !important;
    color: #fff !important;
    border: 2px solid white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: large;
    margin-top: 8px;
    margin-left: 18rem;
    text-wrap: nowrap;
  }
  
  @media (max-width: 768px) {
    .db24{
      padding-top: 0px !important;
      margin-left: 0px;
    }}

    @media (min-width: 768px) and (max-width: 1024px) {
      .db24{
        padding-top: 0px !important;
        margin-left: 264px;
      }
      .button-container1{
        padding: 0px;
        margin-left: 0px;
        align-items: flex-start;
      }
    }
.user-back{
  background-color: #474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  margin-left: 290px;
  display: block;
}
.user-left-div {
  height: auto;
  padding-bottom: 20px;
}
.user-objective31{
  position: relative;
  /* width: 550px; */
  /* padding: 20px; */
  overflow: hidden;
}

.objective-para31 {
  font-size: 15px;
  font-weight: 500;
  color: #000;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  display: block;
  white-space: normal;
  text-align: justify;
}

.project-para31 {
  font-size: 15px;
  font-weight: 500;
  color: #000;
  
  max-width: 100%;
  display: block;
  white-space: normal;
  text-align: justify;
}
.user-image24 {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 2px solid rgba(104, 99, 99, 0.804);
  object-fit: cover;
  margin-right: 15px;
  position: relative;
  top: 50px;
  left: 50px;
}

.user-name {
  font-size: 40px !important;
  font-weight: 900;
  position: relative;
  left: 70px;
  margin: 0;
  margin-top: -36px;
  color: white !important;
  
}

.user-work31 {
 font-size: 18px;
  font-weight: 700;
  position: relative;
  top: 20px;
  left: -100px;
  /* margin: 0; */
  
  
}

.user-hr {
  width: 30%;
  border: 2px solid #a0132b;
  margin: 10px 0;
}

.user-heading {
  color: #a03d4d;
  font-size: 22px;
}

.user-footer {
  width: 100%;
  height: 22px;
  background: #a03d4d;
  margin-top: -8px;
}

.user-footer p {
  color: white;
  text-align: center;
  font-size: 14px;
  margin: 0;
}

.user-footer p a {
  color: white;
  text-decoration: none;
}

.user-footer p a:hover {
  text-decoration: underline;
  color: black;
}

@media screen and (max-width: 575px) {
 .user-container{
  margin-left: 40px;
 }

  
  
}
/* PDF Export Optimizations */
@media print {
  body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 10mm;
      font-size: 12px;
  }
  .page-break {
      page-break-before: always;
  }
  .user-container {
      width: 100%;
      max-width: 100%;
      padding: 0;
  }

  .user-header {
      height: auto;
      padding: 10px;
  }

  .user-image24 {
      width: 150px;
      height: 150px;
      top: 30px;
      left: 20px;
  }

  .user-footer {
      page-break-before: always;
      /* Ensures proper page break */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp2424.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB;uBACqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE;MACE,2BAA2B;MAC3B,gBAAgB;IAClB,CAAC;;IAED;MACE;QACE,2BAA2B;QAC3B,kBAAkB;MACpB;MACA;QACE,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;MACzB;IACF;AACJ;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,uBAAuB;;AAEzB;;AAEA;CACC,eAAe;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;;;AAGjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;CACC;EACC,iBAAiB;CAClB;;;;AAID;AACA,6BAA6B;AAC7B;EACE;MACI,YAAY;MACZ,aAAa;MACb,SAAS;MACT,aAAa;MACb,eAAe;EACnB;EACA;MACI,yBAAyB;EAC7B;EACA;MACI,WAAW;MACX,eAAe;MACf,UAAU;EACd;;EAEA;MACI,YAAY;MACZ,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,aAAa;MACb,SAAS;MACT,UAAU;EACd;;EAEA;MACI,yBAAyB;MACzB,8BAA8B;EAClC;AACF","sourcesContent":[".user-scroll-container{\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n}\r\n.user-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  width: 100%;\r\n  max-width: 900px;\r\n  justify-content: center;\r\n  align-items: flex-end;\r\n  margin: 0 auto;\r\n}\r\n\r\n.user-scroll-container2{\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  width: 114%;\r\n}\r\n\r\n.user-header {\r\n  height: 150px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  background: #a03d4d;\r\n  color: white;\r\n  padding: 15px;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n.resume24 {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  /* border: 1px solid #ddd;\r\n  border-radius: 8px; */\r\n  overflow: hidden;\r\n  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);\r\n} \r\n.back-button24{\r\n  position: relative;\r\n    background-color: #474559 !important;\r\n    color: #fff !important;\r\n    border: 2px solid white;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: bold;\r\n    font-size: large;\r\n    margin-top: 8px;\r\n    left: 5px;\r\n    display: block;\r\n  }\r\n  .db24 {\r\n    justify-self: end;\r\n  }\r\n  .db24{\r\n  \r\n    background-color:#474559 !important;\r\n    color: #fff !important;\r\n    border: 2px solid white;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: bold;\r\n    font-size: large;\r\n    margin-top: 8px;\r\n    margin-left: 18rem;\r\n    text-wrap: nowrap;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .db24{\r\n      padding-top: 0px !important;\r\n      margin-left: 0px;\r\n    }}\r\n\r\n    @media (min-width: 768px) and (max-width: 1024px) {\r\n      .db24{\r\n        padding-top: 0px !important;\r\n        margin-left: 264px;\r\n      }\r\n      .button-container1{\r\n        padding: 0px;\r\n        margin-left: 0px;\r\n        align-items: flex-start;\r\n      }\r\n    }\r\n.user-back{\r\n  background-color: #474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  margin-left: 290px;\r\n  display: block;\r\n}\r\n.user-left-div {\r\n  height: auto;\r\n  padding-bottom: 20px;\r\n}\r\n.user-objective31{\r\n  position: relative;\r\n  /* width: 550px; */\r\n  /* padding: 20px; */\r\n  overflow: hidden;\r\n}\r\n\r\n.objective-para31 {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #000;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  max-width: 100%;\r\n  display: block;\r\n  white-space: normal;\r\n  text-align: justify;\r\n}\r\n\r\n.project-para31 {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #000;\r\n  \r\n  max-width: 100%;\r\n  display: block;\r\n  white-space: normal;\r\n  text-align: justify;\r\n}\r\n.user-image24 {\r\n  width: 200px;\r\n  height: 200px;\r\n  border-radius: 50%;\r\n  border: 2px solid rgba(104, 99, 99, 0.804);\r\n  object-fit: cover;\r\n  margin-right: 15px;\r\n  position: relative;\r\n  top: 50px;\r\n  left: 50px;\r\n}\r\n\r\n.user-name {\r\n  font-size: 40px !important;\r\n  font-weight: 900;\r\n  position: relative;\r\n  left: 70px;\r\n  margin: 0;\r\n  margin-top: -36px;\r\n  color: white !important;\r\n  \r\n}\r\n\r\n.user-work31 {\r\n font-size: 18px;\r\n  font-weight: 700;\r\n  position: relative;\r\n  top: 20px;\r\n  left: -100px;\r\n  /* margin: 0; */\r\n  \r\n  \r\n}\r\n\r\n.user-hr {\r\n  width: 30%;\r\n  border: 2px solid #a0132b;\r\n  margin: 10px 0;\r\n}\r\n\r\n.user-heading {\r\n  color: #a03d4d;\r\n  font-size: 22px;\r\n}\r\n\r\n.user-footer {\r\n  width: 100%;\r\n  height: 22px;\r\n  background: #a03d4d;\r\n  margin-top: -8px;\r\n}\r\n\r\n.user-footer p {\r\n  color: white;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.user-footer p a {\r\n  color: white;\r\n  text-decoration: none;\r\n}\r\n\r\n.user-footer p a:hover {\r\n  text-decoration: underline;\r\n  color: black;\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n .user-container{\r\n  margin-left: 40px;\r\n }\r\n\r\n  \r\n  \r\n}\r\n/* PDF Export Optimizations */\r\n@media print {\r\n  body {\r\n      width: 210mm;\r\n      height: 297mm;\r\n      margin: 0;\r\n      padding: 10mm;\r\n      font-size: 12px;\r\n  }\r\n  .page-break {\r\n      page-break-before: always;\r\n  }\r\n  .user-container {\r\n      width: 100%;\r\n      max-width: 100%;\r\n      padding: 0;\r\n  }\r\n\r\n  .user-header {\r\n      height: auto;\r\n      padding: 10px;\r\n  }\r\n\r\n  .user-image24 {\r\n      width: 150px;\r\n      height: 150px;\r\n      top: 30px;\r\n      left: 20px;\r\n  }\r\n\r\n  .user-footer {\r\n      page-break-before: always;\r\n      /* Ensures proper page break */\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
